export const WeekConditionsType = {
    SUN: 'sun',
    MON: 'mon',
    TUE: 'tue',
    WED: 'wed',
    THU: 'thu',
    FRI: 'fri',
    SAT: 'sat',
    HOL: 'hol',
    PREOFF: 'preoff',
} as const;

export const WeekConditionsShortString = {
    sun: '日',
    mon: '月',
    tue: '火',
    wed: '水',
    thu: '木',
    fri: '金',
    sat: '土',
    hol: '祝',
    preoff: '祝前',
} as const;

export const WeekConditionsLongString = {
    sun: '日曜日',
    mon: '月曜日',
    tue: '火曜日',
    wed: '水曜日',
    thu: '木曜日',
    fri: '金曜日',
    sat: '土曜日',
    hol: '祝日',
    preoff: '祝前日'
} as const;

export type WeekConditionsType = typeof WeekConditionsType[keyof typeof WeekConditionsType];

export const AllWeekConditionsType = Object.values(WeekConditionsType);
